const awsAppSyncConfig = {
    aws_appsync_graphqlEndpoint: "https://h5d7cqtrjnhw7mc7pktq467y6q.appsync-api.us-east-1.amazonaws.com/graphql",
    // aws_appsync_graphqlEndpoint: "https://ztod4ik4mrgqpj5v4k4ypr6yl4.appsync-api.us-east-1.amazonaws.com/graphql",
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: 'userPool',
    aws_appsync_apiKey: "da2-tax3nurfvracrh527dgmfxvdlm",
};

export default awsAppSyncConfig;
